import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-gen-mahalle-cadde-sokak-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';

import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {GenMahalleCaddeSokakService} from "../ctl-gen-mahalle-cadde-sokak.service";
import {DlistDto} from "@dabnet-kamu/libs/ui";
import { ControlConditionModel } from '../../../../models/gen-control.model';

@Component({
  selector: 'dk-ctl-gen-mahalle-cadde-sokak-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-gen-mahalle-cadde-sokak-arama.component.html',
  styleUrls: ['./ctl-gen-mahalle-cadde-sokak-arama.component.scss'],
})
export class CtlGenMahalleCaddeSokakAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Input() controlCondition: ControlConditionModel[];
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private genMahalleCaddeSokakService:GenMahalleCaddeSokakService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control,this.controlCondition);
    this.gridControlsList$ = this.genMahalleCaddeSokakService.gridControlsList$;
    this.genMahalleCaddeSokakService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}

